import React from 'react';
import { Check, X } from 'lucide-react';
export function Comparison() {
  return <section className="py-20 bg-stone-900 text-white" data-id="element-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-15">
            Why This Is Different
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-16">
          {/* The "NO" Column */}
          <div className="bg-stone-800/50 rounded-2xl p-8 border border-stone-700" data-id="element-17">
            <h3 className="text-xl font-bold text-red-400 mb-6 uppercase tracking-wider" data-id="element-18">
              What We Avoid
            </h3>
            <ul className="space-y-6" data-id="element-19">
              <li className="flex items-start" data-id="element-20">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center mt-0.5" data-id="element-21">
                  <X className="w-5 h-5 text-red-400" data-id="element-22" />
                </div>
                <span className="ml-4 text-lg text-stone-300" data-id="element-23">
                  <strong className="text-white" data-id="element-24">NO</strong> intense cardio that
                  destroys your joints.
                </span>
              </li>
              <li className="flex items-start" data-id="element-25">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center mt-0.5" data-id="element-26">
                  <X className="w-5 h-5 text-red-400" data-id="element-27" />
                </div>
                <span className="ml-4 text-lg text-stone-300" data-id="element-28">
                  <strong className="text-white" data-id="element-29">NO</strong> expensive
                  supplements or hard-to-find ingredients.
                </span>
              </li>
              <li className="flex items-start" data-id="element-30">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center mt-0.5" data-id="element-31">
                  <X className="w-5 h-5 text-red-400" data-id="element-32" />
                </div>
                <span className="ml-4 text-lg text-stone-300" data-id="element-33">
                  <strong className="text-white" data-id="element-34">NO</strong> monthly
                  subscriptions.
                </span>
              </li>
            </ul>
          </div>

          {/* The "YES" Column */}
          <div className="bg-amber-900/20 rounded-2xl p-8 border border-amber-500/30 relative overflow-hidden" data-id="element-35">
            <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/10 rounded-full blur-3xl -mr-16 -mt-16" data-id="element-36"></div>

            <h3 className="text-xl font-bold text-amber-400 mb-6 uppercase tracking-wider" data-id="element-37">
              What You Get
            </h3>
            <ul className="space-y-6 relative z-10" data-id="element-38">
              <li className="flex items-start" data-id="element-39">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center mt-0.5" data-id="element-40">
                  <Check className="w-5 h-5 text-green-400" data-id="element-41" />
                </div>
                <span className="ml-4 text-lg text-stone-100" data-id="element-42">
                  <strong className="text-white" data-id="element-43">YES:</strong> 100% Natural
                </span>
              </li>
              <li className="flex items-start" data-id="element-44">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center mt-0.5" data-id="element-45">
                  <Check className="w-5 h-5 text-green-400" data-id="element-46" />
                </div>
                <span className="ml-4 text-lg text-stone-100" data-id="element-47">
                  <strong className="text-white" data-id="element-48">YES:</strong> Science-backed
                </span>
              </li>
              <li className="flex items-start" data-id="element-49">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center mt-0.5" data-id="element-50">
                  <Check className="w-5 h-5 text-green-400" data-id="element-51" />
                </div>
                <span className="ml-4 text-lg text-stone-100" data-id="element-52">
                  <strong className="text-white" data-id="element-53">YES:</strong> Ancestral-proven
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}